<template>
	<div>
		<div class="index" v-loading.fullscreen.lock="fullscreenLoading">
			<div class="search ">
				<div class="sousuo flex_start">
					<i class="el-icon-search" ></i>
					<input type="" style="border:none;outline:none !important;"
						placeholder="Search by Transaction Hash" v-model="key"
						v-on:keyup.enter="search" />
						<span class="bottom"></span>
						  <span class="right"></span>
						  <span class="top"></span>
						  <span class="left"></span>
				</div>
				<div class="order-index" v-if="isResult">
					<div class="m view">
						<div class="head">
							<img src="../../assets/images/index/icon_order.svg" style="width:100px;height:100px;" />
							<div>Status Success</div>
						</div>
						<div class="body flex_between_x">
							<ul class="left_ul">
								<li>
									<div class="label">Cover:
									</div>
									<div class="font"><img :src="info.cover" alt="" srcset=""></div>
								</li>
								<li>
									<div class="label">TX ID:
									</div>
									<div class="font">{{info.tid}}</div>
								</li>
								<li>
									<div class="label">Transaction Hash:
									</div>
									<div class="font">{{info.hash}}</div>
								</li>
								<li>
									<div class="label">Contract address:
									</div>
									<div class="font">{{info.contractAddress}}</div>
								</li>
								<li>
									<div class="label">Timestamp:
									</div>
									<div class="font">{{info.timestamp}}</div>
								</li>
								<li>
									<div class="label">Sender:
				
									</div>
									<div class="font" style="cursor:pointer;">
										{{info.sender}}
									</div>
								</li>
								<li>
									<div class="label">Receiver:
				
									</div>
									<div class="font" style="cursor:pointer;">
										{{info.receiver}}
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
			
		</div>
	</div>
</template>

<script>
	export default {
		name: 'index',
		data() {
			return {
				bgc: '#000000',
				flag: true,
				input: "",
				information: "",
				tableData: [],
				total: 0,
				fullscreenLoading: false,
				key: "",
				isResult:false,
				info:{}
			}
		},
		mounted() {
			
		},
		methods: {
			async get2(page) {
				let res = await this.$api.index2({
					page: page,
					pagesize: 10
				})
				if (res.code == 200) {
					this.fullscreenLoading = false
					this.tableData = res.data
					this.total = Number(res.totalCount)
					this.tableData.forEach(item => {
						item.pay_time = formatDate(item.pay_time * 1000)
					})
				} else {
					this.fullscreenLoading = false;
					this.$message({
						message: 'error',
						type: 'error'
					});
				}

				console.log(res.data)
			},
			nav_details(item) {
				console.log(item)
				this.$router.push({
					name: 'order',
					query: {
						tx: item.order_no
					}
				})
			},
			nav_r_address(item) {
				this.$router.push({
					name: 'address',
					query: {
						contract_address: item.r_contract_address
					}
				})
			},
			nav_shop(item) {
				this.$router.push({
					name: 'shop',
					query: {
						tid: item.tid
					}
				})
			},
			nav_s_address(item) {
				this.$router.push({
					name: 'address',
					query: {
						contract_address: item.s_contract_address
					}
				})
			},
			tableRowClassName({
				row,
				rowIndex
			}) {
				if (rowIndex === 1) {
					return 'warning-row';
				} else if (rowIndex === 3) {
					return 'success-row';
				}
				return '';
			},
			xuanze(val) {
				console.log(val)
				this.fullscreenLoading = true
				this.get2(val)
			},
			openFullScreen1() {
				this.fullscreenLoading = true;
			},
			async search(){
				this.fullscreenLoading = true
				let res = await this.$api.index({
					hash:this.key
				})
				if (res.status.code == 0) {
					if(res.result){
						this.fullscreenLoading = false
						this.isResult=true
						this.info=res.result
					}else{
						this.fullscreenLoading = false
						this.isResult=false
						this.key=""
						this.$message({
							message: '请检查该交易哈希是否正确',
							type: 'error'
						});
					}
				} else {
					this.key=""
					this.isResult=false
					this.fullscreenLoading = false;
					this.$message({
						message: res.status.msg,
						type: 'info'
					});
				}
				console.log(res.data)
			}
		}
	}
</script>

<style lang="scss" scoped>
	html,
	body {
		width: 100%;
		height: 100%;
		margin: 0;
	}

	.index {
		width: 100%;
		margin-top: 70px;
		// padding-bottom: 100px;

		.search {
			background-image: url(../../assets/images/index/bg.svg);
			min-height: 800px;
			height:auto;
			display: flex;
			justify-content: center;
			align-items: center;
			flex-wrap: wrap;
			padding:80px 0px;
			.sousuo {
				width: 600px;
				height: 60px;
				// border-radius: 8px;
				// border: 1px solid #000000;
				padding: 10px;
				background-color: #FFFFFF;
				cursor: pointer;
				overflow: hidden;
				i{
					font-size:20px;
				}
				input {
					width: 100%;
					margin-left: 10px;
					cursor: pointer;
					transition: background-color 0.3s ease-in-out;
					height:100%;
					font-size:18px;
				}
			}
		}

		.statistical {
			margin-top: 20px;
			display: flex;
			justify-content: space-between;
			align-items: flex-start;
			flex-wrap: wrap;

			.sitem {
				width: 100%;
				height: 290px;
				display: flex;
				justify-content: space-between;
				flex-wrap: wrap;

				.mokuai_item {
					width: 49%;
					height: 135px;
					// border:1px solid #C0C0C0;
					align-items: center;
					box-shadow: 0 1px 23px 0 #f1f1f1;
					border-radius: 6px;
					padding: 24px 32px;

					p {
						font-size: 16px;
						color: #999;
						margin-bottom: 14px;
					}

					span {
						font-size: 32px;
						color: #000000;
					}

					i {
						font-size: 40px;
					}
				}
			}
		}

		.table_list {
			margin-top: 30px;
		}

	}

	@media screen and (max-width: 720px) {
		.search {
			height: 200px !important;
			;

			.sousuo {
				width: 80% !important;
			}
		}

		.statistical {
			.sitem {
				width: 100% !important;
				height: auto !important;
				padding: 10px !important;

				.mokuai_item {
					width: 100% !important;
					margin-bottom: 20px;
				}
			}
		}
	}

	.el-table .warning-row {
		background: oldlace;
	}

	.el-table .success-row {
		background: #f0f9eb;
	}
	
	div {
	  position: relative;
	}
	
	
	input:focus {
	  outline: none;
	}
	
	input::placeholder {
		font-size:18px;
	  // color: hsla(0, 0%, 100%, 0.6);
	}
	
	span {
	  position: absolute;
	  background-color: #333333;
	  transition: transform 0.5s ease;
	}
	
	.bottom,
	.top {
	  height: 2px;
	  left: 0;
	  right: 0;
	  transform: scaleX(0);
	}
	
	.left,
	.right {
	  width: 2px;
	  top: 0;
	  bottom: 0;
	  transform: scaleY(0);
	}
	
	.bottom {
	  bottom: 0;
	  transform-origin: bottom right;
	}
	
	input:focus ~ .bottom {
	  transform-origin: bottom left;
	  transform: scaleX(1);
	}
	
	.right {
	  right: 0;
	  transform-origin: top right;
	}
	
	input:focus ~ .right {
	  transform-origin: bottom right;
	  transform: scaleY(1);
	}
	
	.top {
	  top: 0;
	  transform-origin: top left;
	}
	
	input:focus ~ .top {
	  transform-origin: top right;
	  transform: scaleX(1);
	}
	
	.left {
	  left: 0;
	  transform-origin: bottom left;
	}
	
	input:focus ~ .left {
	  transform-origin: top left;
	  transform: scaleY(1);
	}
	.order-index {
		width: 75%;
		margin-top: 10px;
		padding-bottom: 100px;
	
		.view {
			text-align: center;
			padding: 20px 0px;
	
			.head {
				div {
					font-size: 24px;
					margin-top: 20px;
				}
			}
	
			.body {
				width: 100%;
				box-shadow: 0 1px 23px 0 #b9b9b9;
				margin-top: 40px;
				padding: 40px 80px;
				align-items: center;
				border-radius: 5px;
	
				.left_ul {
					display: inline-block;
	
					li {
						display: flex;
						justify-content: flex-start;
						height: 50px;
						line-height: 50px;
	
						.label {
							font-size: 20px;
							width: 200px;
							text-align: left;
						}
	
						.font {
							color: #74777e;
							font-size: 20px;
							display: flex;
							align-items: center;
							img{
								width:60px;
								height:auto;
							}
						}
					}
				}
	
				.right_img {
					width: 220px;
					border: 1px solid #000000;
					border-radius: 10px;
					overflow: hidden;
	
					.font {
						border-bottom: 1px solid #CCCCCC;
						padding: 10px;
						text-align: left;
	
						.title {
							font-size: 14px;
							font-weight: 550;
							margin-bottom: 10px;
						}
					}
				}
			}
		}
	}
</style>
